import axios from "axios";
import { clearStorage, getToken } from "../utils/storage";
import { removeToken } from "../store/feature/user";
import Swal from "sweetalert2";

export const setHeaderRequest = (res: any) => {
  const token = getToken();
  if (token) {
    res.headers["Authorization"] = `Bearer ${token}`;
  }
  return res;
};

export const setError = (err: any) => {
  if (err.response) {
    if (
      err.response.status === 401 &&
      err?.response.data.message === "Invalid or expired token"
    ) {
      removeToken();
      clearStorage();
      window.location.href = "/login";
    } else {
      if (
        err?.response.data.msg ===
        `You don't have access for SYS_CONFIG Project`
      ) {
        Swal.fire({
          icon: "error",
          title: "Error Login",
          text: "Role has not been assign for this module",
        });
      } else if (
        err?.response.data.msg === 'error on getting certificate details') {
        Swal.fire({
          icon: "error",
          title: "Error View Certificate",
          text: `Can’t display certificate on web. Please download the certificate with the “Download as PEM” in this page or "Download Certificate" in the CA Structure & CRLs page`,
        });
      } else {
        console.log(err?.response.data, " ===========> error from Api response");
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err?.response.data.message || err?.response.data.msg,
        });
      }
    }
  }
  return Promise.reject(err);
};

export const setHeaderResponse = (res: any) => {
  return res;
};

export const instanceAdmin = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_ADMIN,
  timeout: 300000,
});

instanceAdmin.interceptors.request.use(setHeaderRequest, setError);
instanceAdmin.interceptors.response.use(setHeaderResponse, setError);

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  timeout: 300000,
});

instance.interceptors.request.use(setHeaderRequest, setError);
instance.interceptors.response.use(setHeaderResponse, setError);

export const instanceNon = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_NON,
  timeout: 300000,
});

instanceNon.interceptors.request.use(setHeaderRequest, setError);
instanceNon.interceptors.response.use(setHeaderResponse, setError);

export const instanceFormEditor = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_FORM_EDITOR,
  timeout: 300000,
});

instanceFormEditor.interceptors.request.use(setHeaderRequest, setError);
instanceFormEditor.interceptors.response.use(setHeaderResponse, setError);
